export default __webpack_public_path__ + "static/media/chair-icon.77994353.svg";